exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.all-tasks[data-v-0ac03a9c] .v-image__image--cover {\n  background-size: auto !important;\n  display: list-item;\n}\n.link-green[data-v-0ac03a9c]{\n  color: #3c763d !important;\n}\n.v-chip.v-size--default[data-v-0ac03a9c] {\n  border-radius: 23px !important;\n  font-size: 16px !important;\n  height: 46px !important;\n}\n", ""]);

// exports
